import { DATA_DS_DEMO_DNA2_1 } from "./DSDemo/205DSDemoDNA2_1";
import { DATA_DS_DEMO_DNA2_2 } from "./DSDemo/206DSDemoDNA2_2";
import { DATA_DS_DEMO_DNA2_3 } from "./DSDemo/207DSDemoDNA2_3";
import { DATA_DS_DEMO_DNA2_4 } from "./DSDemo/208DSDemoDNA2_4";
import { DATA_DS_DEMO_DNA2_5 } from "./DSDemo/209DSDemoDNA2_5";
import { DATA_DS_DEMO_DNA2_6 } from "./DSDemo/210DSDemoDNA2_6";
import { DATA_DS_DEMO_DNA2_7 } from "./DSDemo/211DSDemoDNA2_7";
import { DATA_DS_DEMO_DNA2_8 } from "./DSDemo/212DSDemoDNA2_8";
import { DATA_DS_DEMO_DNA2_9 } from "./DSDemo/213DSDemoDNA2_9";
import { DATA_DS_DEMO_DNA2_END } from "./DSDemo/214DSDemoDNA2_End";
import { DATA_INTRO_DNA2 } from "./Introduction/201DataIntroDNA2";
import { DATA_BENEFITS_DNA2_1 } from "./Introduction/202DataBenefitsDNA2_1";
import { DATA_BENEFITS_DNA2_2 } from "./Introduction/203DataBenefitsDNA2_2";
import { DATA_CHARACTERS_DNA2 } from "./Introduction/204DataCharactersDNA2";

export const DNA2_WORKFLOW = [
  { page: 201, type: "intro-template" as TemplateType, data: DATA_INTRO_DNA2 },
  {
    page: 202,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_DNA2_1,
  },
  {
    page: 203,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_DNA2_2,
  },
  {
    page: 204,
    type: "characters-template" as TemplateType,
    data: DATA_CHARACTERS_DNA2,
  },
  {
    page: 205,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_1,
  },
  {
    page: 206,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_2,
  },
  {
    page: 207,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_3,
  },
  {
    page: 208,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_4,
  },
  {
    page: 209,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_5,
  },
  {
    page: 210,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_6,
  },
  {
    page: 211,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_7,
  },
  {
    page: 212,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_8,
  },
  {
    page: 213,
    type: "journey-two-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_9,
  },
  {
    page: 214,
    type: "end-template" as TemplateType,
    data: DATA_DS_DEMO_DNA2_END,
  },
];
